<mds-card [appearance]="'outlined'">
    <!-- mds-card-content has its own padding of 1.6rem -->
    <mds-card-content>
        <div class="p-medpace flex flex-col gap-medpace *:grid *:grid-cols-3 *:gap-medpace">
            <h5>Receipt {{ index() + 1 }}</h5>
            <div>
                <medpace-labeled-text [label]="'Receipt Type'" [text]="receiptType()?.viewValue" />
            </div>

            <div>
                <medpace-labeled-text
                    [label]="'Receipt Date'"
                    [text]="
                        (model().receiptDate?.toDate() | dateFormat: DateFormat.dateOnly : 'local' | uppercase) ??
                        'Unspecified'
                    "
                />
                <medpace-labeled-text
                    [label]="model().currencyCode ? 'Receipt Amount (' + model().currencyCode + ')' : 'Receipt Amount'"
                    [text]="(model().amountLocalCurrency | number: '1.2-2' : 'en-US') ?? 'Unspecified'"
                />
                @if (!isCrc) {
                    @if (amountUsdChip()) {
                        <mds-chip [chips]="amountUsdChip()" [chipListType]="'basic'" [multiple]="true"></mds-chip>
                    }
                }
            </div>
            @if (model().attachmentInfoId) {
                <div>
                    <div>
                        <h5>Attachment</h5>
                        <a (click)="downloadAttachment()">Download</a>
                    </div>
                </div>
            }
            @if (!isCrc) {
                <medpace-merchant-details-view [model]="model()" />
                <div>
                    <medpace-labeled-text
                        class="break-words"
                        [label]="'Expense Report Tracking ID'"
                        [text]="model().erTrackingId ?? 'Unspecified'"
                    />

                    <medpace-labeled-text
                        class="break-words"
                        [label]="'ER Reporting Period'"
                        [text]="model().erReportingPeriod ?? 'Unspecified'"
                    />
                </div>
            }
            @let isInProcessOrHigher = isInProcessOrHigher$ | async;
            @let elevatedAccess = elevatedAccess$ | async;
            @if (isInProcessOrHigher === true && elevatedAccess === true) {
                <div>
                    <div class="col-span-4 break-words">
                        <h5>Notes</h5>
                        <span>{{ model().notes ?? 'Unspecified' }}</span>
                    </div>
                </div>
            }
        </div>
    </mds-card-content>
</mds-card>
